module.exports = __webpack_public_path__ + "4b2523ecfe3085d6fd5a51d53ff3395d.ico";